<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0C11.5523 0 12 0.447715 12 1V6H17C17.5523 6 18 6.44772 18 7C18 7.55228 17.5523 8 17 8H11C10.4477 8 10 7.55228 10 7V1C10 0.447715 10.4477 0 11 0Z" fill="#858E97"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6 2C4.89543 2 4 2.89543 4 4V16C4 17.1046 4.89542 18 6 18H14C15.1046 18 16 17.1046 16 16V7.41421L10.5858 2H6ZM2 4C2 1.79087 3.79087 0 6 0H11C11.2652 0 11.5196 0.105357 11.7071 0.292893L17.7071 6.29289C17.8946 6.48043 18 6.73478 18 7V16C18 18.2092 16.2092 20 14 20H6C3.79088 20 2 18.2092 2 16V4Z" fill="#858E97"/>
    </svg>
</template>

<script>
export default {
    name: 'IconDocumentSmall',

    props: ['className']
};
</script>

<style lang="scss">
@import "Icons";
</style>
